import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/ShortInfo.module.scss'

import { Container } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'

class ShortInfo extends React.Component {
  
  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data, assets_path, hide_subtitle, margin } = this.props

    return (
      <section className={`${styles.section} ${styles[`margin-${margin}`]}`}>
        <Container>
          {data?.title != '' &&
            <WhiteBlockTitle
              title={data?.title || ``}
              text={data?.rtext || ``}
              className={styles.otitle}
            />
          }
          <div className={styles.content}>
            {!hide_subtitle &&
              <div className={styles.title}>Краткая информация</div>
            }
            <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text}} />
          </div>
        </Container>
      </section>
    )
  }
}

ShortInfo.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string,
  hide_subtitle: PropTypes.bool,
  margin: PropTypes.string
}

ShortInfo.defaultProps = {
  data: {},
  assets_path: ``,
  hide_subtitle: false,
  margin: `top`
}

export default ShortInfo